import React, { Component } from "react";
import AppBar from "./AppBar";
import { withStyles } from "material-ui/styles";
import PropTypes from "prop-types";
import { Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import LoginPage from "./LoginPage";
import SetupFlowPage from "./SetupFlowPage";
import FeedPage from "./FeedPage";
import FrontLandingPage from "./FrontLandingPage";
import { grey } from "material-ui/colors";
import UserProfilePage from "./UserProfilePage";
import { initiateLoginCheck } from "../actions/login.actions";
import ViewPostPage from "./ViewPostPage";
import NotificationsPage from "./NotificationsPage";

const styleSheet = theme => ({
    container: {
        display: "flex"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200
    },
    app: {
        height: "100%",
        minHeight: "100vh",
        backgroundColor: grey[100],
        flexDirection: "column",
        display: "flex"
    },
    frontPage: {
        height: "100%",
        minHeight: "100vh",
        backgroundColor: "#fff",
        flexDirection: "column",
        display: "flex"
    },
    contentClass: {
        marginTop: 64
    }
});

class App extends Component {
    componentWillMount() {
        this.props.dispatch(initiateLoginCheck());
    }

    routes = () => {
        const { userSettings } = this.props;

        let paths = [];
        paths.push(
            <Route
                key="login"
                path="/login"
                render={props =>
                    userSettings.loggedIn
                        ? <Redirect to="/feed" />
                        : <LoginPage {...props} />}
            />
        );
        paths.push(
            <Route
                key="landingPage"
                exact
                path="/"
                render={() =>
                    userSettings.loggedIn
                        ? <Redirect to="/feed" />
                        : <FrontLandingPage />}
            />
        );
        if (userSettings.loggedIn) {
            paths = paths.concat([
                <Route
                    key="setup"
                    path="/setup/step/:step"
                    component={SetupFlowPage}
                />,
                <Route key="feed" path="/feed" component={FeedPage} />,
                <Route
                    key="profile"
                    path="/profile/:uid"
                    component={UserProfilePage}
                />,
                <Route
                    key="post"
                    path="/posts/:postId"
                    component={ViewPostPage}
                />,
                <Route
                    key="notifications"
                    path="/notifications"
                    component={NotificationsPage}
                />,
                <Route key="nopath" render={() => <Redirect to="/feed" />} />
            ]);
        }

        return (
            <Switch>
                {paths}
            </Switch>
        );
    };

    render() {
        const { classes } = this.props;
        let containerClass = classes.app;
        if (this.props.location.pathname === "/") {
            containerClass = classes.frontPage;
        }
        return (
            <div className={containerClass}>
                <AppBar />
                <div className={classes.contentClass}>
                    {this.routes()}
                </div>
            </div>
        );
    }
}

function mapStateToProps({ userSettings }) {
    return {
        userSettings
    };
}

App.propTypes = {
    userSettings: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
};

export default connect(mapStateToProps)(withStyles(styleSheet)(App));



// WEBPACK FOOTER //
// ./src/containers/App.jsx